import { IconType, SvgIcon } from './SvgIcon';

export const LoadingIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0.5 0 32 32">
    <g clipPath="url(#clip0)">
      <g transform="matrix(0.0102788 -0.00804848 -0.00801618 -0.0102375 16.5 16)">
        <foreignObject x="-1835.45" y="-1835.45" width="3670.91" height="3670.91">
          <div
            style={
              {
                '--conic-color': 'currentColor',
                background:
                  'conic-gradient(from 90deg, var(--conic-color) 0deg, transparent 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1,
              } as any
            }
          />
        </foreignObject>
      </g>
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32ZM16.5 27.1515C22.6588 27.1515 27.6515 22.1588 27.6515 16C27.6515 9.84114 22.6588 4.84844 16.5 4.84844C10.3411 4.84844 5.34844 9.84114 5.34844 16C5.34844 22.1588 10.3411 27.1515 16.5 27.1515Z"
      fill="url(#angularGradient)"
    />
    <ellipse
      cx="27.0798"
      cy="7.48664"
      rx="2.39955"
      ry="2.5"
      transform="rotate(-9.21826 27.0798 7.48664)"
      fill="currentColor"
    />
    <defs>
      <clipPath id="clip0">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32ZM16.5 27.1515C22.6588 27.1515 27.6515 22.1588 27.6515 16C27.6515 9.84114 22.6588 4.84844 16.5 4.84844C10.3411 4.84844 5.34844 9.84114 5.34844 16C5.34844 22.1588 10.3411 27.1515 16.5 27.1515Z"
        />
      </clipPath>
      <radialGradient id="angularGradient">
        <stop offset="0%" stopColor="currentColor" stopOpacity="1" />
        <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
      </radialGradient>
    </defs>
  </SvgIcon>
);

LoadingIcon.displayName = 'LoadingIcon';
